import React, { memo } from "react";

const TestProgress = memo(function TestProgress({
  mockData,
  questions,
  currentQuestion,
  pending,
}) {

  const currentQuestionNumber = () => {
    return pending 
      ? currentQuestion + mockData?.q_count + 1
      : currentQuestion + 1;
  };

  const totalQuestions = () => {
    return pending  ? questions?.length + mockData?.q_count : questions.length;
  };


  return (
    <div className="item">
      <p>
        Question {currentQuestionNumber()} of {totalQuestions()}
          {/* Question {currentQuestion + mockData?.q_count + 1} of {questions?.length + mockData?.q_count} */}
      </p>
    </div>
  );
});

export default TestProgress;
